/**
 * Sub1 Template
 * @category testApp
 */
class AbilityleftlayerTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     */
    static getLeftLayerTempl(_d={}) {
        const selectedEffectItem = _d.point.picks.map(AbilityleftlayerTempl.getSelectedEffectTempl).join('');
        let selectedEffectList = ``;

        if(selectedEffectItem === ''){
            selectedEffectList = ``;
        }
        else{
            selectedEffectList = `
            <div class="ability-header-layer-inner">
                <strong class="layer-title">선택 효과</strong>
                <ul class="selected-effect-list">
                    ${selectedEffectItem}
                </ul>
            </div>
            `;
        }
        return `
    	<div class="ability-header-layer-inner">
            <strong class="layer-title">홍문 공격 점수 효과</strong>
            <ul class="point-effect-list">
                <li>
                    <span class="icon-point icon-attack-total"><em class="point-name">공격력</em></span>
                    <span class="point-num">${_d.point.attackPowerValue ? _d.point.attackPowerValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</span>
                </li>
                <li>
                    <span class="icon-point icon-attack-total"><em class="point-name">공력</em></span>
                    <span class="point-num">${_d.point.attackAttributeValue ? (_d.point.attackAttributeValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</span>
                </li>
            </ul>
            <div class="extra-effect-wrap">
                <em class="extra-effect-title">추가효과</em>
                <div class="extra-effect">
                    <div class="effect-row">
                        <div class="effect-th"><span>10</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 10) ? 'is-active' : ''}"><span>공격력 60, 공력 60증가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>20</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 20) ? 'is-active' : ''}"><span>공격력 40, 공력 50증가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>50</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 50) ? 'is-active' : ''}"><span>저항 시 5초간 공격력 100증가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>80</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 80) ? 'is-active' : ''}"><span>공격력 30, 공력 40증가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>100</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 100) ? 'is-active' : ''}"><span>저항 시 5초간 공력 150증가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>115</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 115) ? 'is-active' : ''}"><span>공격력 20, 공력 30증가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>125</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 125) ? 'is-active' : ''}"><span>공격력 15, 공력 20증가가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>135</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 135) ? 'is-active' : ''}"><span>공격력 10, 공력 15증가</span></div>
                    </div>
                    <div class="effect-row">
                        <div class="effect-th"><span>150</span></div>
                        <div class="effect-td ${(_d.point.offensePoint >= 150) ? 'is-active' : ''}"><span>저항 시 5초간 공격력 50, 공력 75증가</span></div>
                    </div>
                </div>
            </div>
        </div>
        ${selectedEffectList}
        <button class="btn-close-layer"><span class="blind">닫기</span><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g fill="none" fill-rule="evenodd" stroke="#1F1F1F" stroke-linecap="square" stroke-width=".5"><path d="M1.051 1.051l17.55 17.55M1.051 18.601l8.754-8.753 6.78-6.782 2.016-2.015"></path></g></svg></button>
    	`;
    }

    static getSelectedEffectTempl(_d={}){
        if(_d.point === 0){
            return ``;
        }
        else if(_d.name === '재생' || _d.name === '이동속도' || _d.name === '상태이상'){
            return ``;
        }
        else{
            let iconName;
            if(_d.name === '위협'){
                iconName = 'icon-attack-1';
            }
            else if(_d.name === '홍문지기'){
                iconName = 'icon-attack-2';
            }
            else{
                iconName = '';
            }
            return `
            <li>
               <div class="selected-effect-title">
                   <span class="title-icon ${iconName}"></span>
                   <em class="title-text">${_d.name} ${_d.tier}단계</em>
               </div>
               <span class="selected-effect-info">${_d.description}</span>
            </li>
            `;
        }
    }


} // end of class

export default AbilityleftlayerTempl;